module.exports = __webpack_public_path__ + "img/img-apart-ponta.0086965e.png";